import { useMemo, useCallback, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  getContractByExhibitor,
  getContractByServiceProvider,
} from "../redux/modules/contract/actions";

/**
 * Hook para obter o eventEditionCode baseado no contrato selecionado
 *
 * Busca automaticamente as informações do contrato quando evento e contrato
 * estão disponíveis no state, e retorna o código da edição do evento.
 *
 * @returns {string|undefined} eventEditionCode - Código da edição do evento
 *
 * @example
 * const eventEditionCode = useEventEditionCode();
 *
 * if (eventEditionCode) {
 *   console.log("Código do evento:", eventEditionCode);
 * }
 */
const useEventEditionCode = () => {
  const dispatch = useDispatch();

  const { event, contract } = useSelector((state) => state.initialSettings);
  const { contractInfo } = useSelector((state) => state.contract);
  const { user } = useSelector((state) => state.auth);

  const userType = useMemo(() => user?.role?.type, [user]);

  const eventEditionCode = useMemo(
    () => contractInfo?.eventEditionCode,
    [contractInfo],
  );

  const loadContractInfo = useCallback(() => {
    if (!event?.value || !contract?.value) return;

    const params = {
      eventId: event.value,
      contractId: contract.value,
    };

    const action =
      userType === "SERVICE_PROVIDER"
        ? getContractByServiceProvider
        : getContractByExhibitor;

    dispatch(action(params, () => {}));
  }, [event?.value, contract?.value, userType, dispatch]);

  useEffect(() => {
    loadContractInfo();
  }, [loadContractInfo]);

  return eventEditionCode;
};

export default useEventEditionCode;
